import { render, staticRenderFns } from "./ModalViewAllocationIndex.vue?vue&type=template&id=7fdd0d0c&scoped=true&"
import script from "./ModalViewAllocationIndex.vue?vue&type=script&lang=js&"
export * from "./ModalViewAllocationIndex.vue?vue&type=script&lang=js&"
import style0 from "./ModalViewAllocationIndex.vue?vue&type=style&index=0&id=7fdd0d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdd0d0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDialog,VIcon,VSimpleTable})
